import React from "react";

const CircularLoader = ({ percentage = 99 }) => {
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 120 120"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background Circle */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#e6e6e6"
          strokeWidth="10"
          fill="none"
        />
        {/* Progress Circle with Animation */}
        <circle
          cx="60"
          cy="60"
          r={radius}
          stroke="#007bff"
          strokeWidth="10"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          style={{
            transition: "stroke-dashoffset 0.3s ease",
            transformOrigin: "center",
            animation: "spin 1s linear infinite", // Add spinning animation
          }}
        />
        {/* Percentage Text */}
        <text
          x="60"
          y="60"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="35"
          fill="#007bff"
        >
          {percentage}%
        </text>
      </svg>

      {/* Add CSS for the spinning animation */}
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default CircularLoader;